import axios from "./axios";

export const apiParseSearchQuery = (query) =>
  axios.post("/ai/parse-search", { query });

// ── External Jobs API ─────────────────────────────────────────────────────────

/**
 * List/search external low-level jobs.
 * @param {{ q?, city?, state?, source_type?, page?, limit? }} params
 */
export const apiGetExternalJobs = (params = {}) =>
  axios.get("/external-jobs", { params });

/**
 * Get single external job by ID.
 */
export const apiGetExternalJob = (id) =>
  axios.get(`/external-jobs/${id}`);

/**
 * Build the redirect URL that tracks the click and redirects to company site.
 * Use as an <a href> target — do NOT call via axios (needs browser redirect).
 */
export const getExternalJobRedirectUrl = (id, source = "web") => {
  const base = process.env.REACT_APP_API_URL || "";
  return `${base}/v1/external-jobs/redirect/${id}?source=${source}`;
};

